import React, { useContext, useEffect, useState } from "react";
import CustomerDetailsCard from "./CustomerDetailsCard";
import FleetSummary from "./FleetSummary";
import TataCareCuponCard from "./TataCareCuponCard";
import SubscriptionDetails from "./SubscriptionDetails";
import ServiceSummary from "./Servicesumtable";
import FleetDetails from "./Fleetpvintable";
import ApplicationSummary from "./Appsummarytb";
import FinancierSummary from "./Finnanciersummary";
import CustomerComplaints from "./Customercomptable";
import RenewalReminders from "./Renewalremindertb";
import SubscriptionDetailstb from "./Subscriptiondetailstb";
import Last5ServiceDetails from "./Lastfivetable";
import Accordianpvin from "./Accordianpvinn";
import Header from "../../components/Header/Header";
import { fetchPvinData, fetchPvinToken } from "./PvinKip";
import { FilterContext } from "../../context/Filter";
import WaterMark from "../../components/WaterMark";
import Search from "../../components/CustSearch/Search";

const PivinIndex = () => {
  const [pvinToken, setPvinToken] = useState(null);
  const [pvinData, setPvinData] = useState(null); //
  const { superArn: parArn, childArn } = useContext(FilterContext);
  // const selectedArnValue = parArn || childArn;
  const selectedArnValue = parArn || childArn;


  // console.log(parArn, "pvinbt")
  // Fetch Token
  const fetchPvinTokenValues = async () => {
    try {
      const response = await fetchPvinToken();
      const token = response?.data?.access_token;
      if (token) {
        setPvinToken(token);
        // console.log("✅ Token fetched successfully:", token);
        return token;
      } else {
        console.error("❌ No token returned from API");
        return null;
      }
    } catch (error) {
      console.error("❌ Error fetching PVIN token:", error);
      throw error;
    }
  };

  // Fetch Data
  const fetchPvinDataValues = async (token) => {
    try {
      if (!token) return console.error("❌ Token missing, skipping data fetch");

      const response = await fetchPvinData(token, selectedArnValue);
      // console.log("✅ PVIN Data Response:", response);

      setPvinData(response);
    } catch (error) {
      console.error("❌ Error fetching PVIN data:", error);
    }
  };

  useEffect(() => {
    const initialize = async () => {
      try {
        const token = await fetchPvinTokenValues();
        await fetchPvinDataValues(token);
      } catch (error) {
        console.error("Initialization error:", error);
      }
    };

    initialize();
  }, [selectedArnValue]);

  return (
    <div>
      <WaterMark />
      <Header />
      <div>
        <Search />

      </div>
      <div className=" block md:flex justify-center items-center gap-16 m-2 ">
        <CustomerDetailsCard data={pvinData || []} />
        <FleetSummary data={pvinData || []} />
        <div className="flex flex-col gap-2">
          <TataCareCuponCard data={pvinData || []} />
          <SubscriptionDetails />
        </div>
      </div>

      <div className=" w-96 md:w-full md:grid p-3 lg:grid-cols-2 md:grid-cols-2 gap-4 flex flex-col">
        <ServiceSummary allData={pvinData?.service_summary || []} />
        <FleetDetails data={pvinData?.Fleet_Details || []} />
      </div>

      <div className=" w-96 md:w-full lg:grid md:grid p-3 lg:grid-cols-2 md:grid-cols-2 gap-4 flex flex-col">
        <FinancierSummary data={pvinData?.Financier_Summary || []} />
        <ApplicationSummary data={pvinData?.Application_Summary || []} />
      </div>

      <div className=" w-96 md:w-full lg:grid md:grid p-3 lg:grid-cols-2 md:grid-cols-2 gap-4 flex flex-col">
        <CustomerComplaints data={pvinData?.Customer_Complaints || []} />
        <RenewalReminders data={pvinData || []} />
      </div>
      <div className="w-96 md:w-full flex flex-col items-center justify-center gap-2">
        <Last5ServiceDetails data={pvinData?.Last_5_Service_Details || []} />
        <SubscriptionDetailstb
          data={pvinData?.["Subscription Details"] || []}
        />
        <Accordianpvin data={pvinData?.Fleetedge_Details || []} />
      </div>
    </div>
  );
};

export default PivinIndex;
